import { useFeedStore } from '@/stores/feed/feedStore'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import { FormattedFeedProductType } from '@/types'
import getProductKey from '@/utils/products/getProductKey'
import { focusProductSearchInput } from '@/utils/search/ui/focusProductSearchInput'

import cn from './ProductName.module.scss'

function ProductName({
  formattedProduct,
}: {
  formattedProduct: FormattedFeedProductType
}) {
  const { children, parent, nomenclatureDto, lastInChildren } = formattedProduct
  const { expandedRows, setExpandedRows } = useFeedStore((state) => state)
  const productKey = String(getProductKey(formattedProduct))
  const isOrganisationSelected = useUserInfoStore(
    (state) => Object.keys(state.selectedOrganisation).length > 0
  )
  const hintClassName = isOrganisationSelected
    ? [cn.hint, cn.hintAccent].join(' ')
    : cn.hint

  const handleExpand = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (!expandedRows.includes(productKey)) {
      setExpandedRows([...expandedRows, productKey])
      focusProductSearchInput()
    }
  }

  const handleCollapse = (e: React.MouseEvent) => {
    e.stopPropagation()
    const parentCode = String(nomenclatureDto.code)
    const newExpandedRowsKeys = expandedRows.filter((key) => {
      return key.split(' ')[0] !== parentCode
    })
    setExpandedRows(newExpandedRowsKeys)
    focusProductSearchInput()
  }

  if (children?.length) {
    return (
      <div className={cn.productNameBlock}>
        <span>{nomenclatureDto.description}</span>
        <span
          onClick={handleExpand}
          className={
            expandedRows.includes(productKey)
              ? [hintClassName, cn.hidden].join(' ')
              : hintClassName
          }
        >
          Остальные предложения...
        </span>
      </div>
    )
  }

  if (lastInChildren) {
    return (
      <span className={hintClassName} onClick={handleCollapse}>
        Свернуть
      </span>
    )
  }

  if (parent) {
    return <span>{nomenclatureDto.description}</span>
  }

  return null
}

export default ProductName
